// import $ from "jquery";

(($) => {
  const el = {
    loyalty_point_total: ".js-loyalty-point-total",
    loyalty_point_btn_submit: ".js-submit-loyalty-point",
    loyalty_point_input: "#loyalty-point",
    loyalty_point_show: "#use-loyalty-point",
    loyalty_point_form: ".js-loyalty-point-form",
  };

  if ($(el.loyalty_point_btn_submit).length < 0) return false;

  const apply_loyalty_point = () => {
    // eslint-disable-next-line no-unused-vars
    $(document).on("click", el.loyalty_point_btn_submit, (e) => {
      const $loyalty_point_input = $(el.loyalty_point_input);

      if (
        parseFloat($loyalty_point_input.val()) >
        parseFloat($loyalty_point_input.attr("max")) ||
        parseFloat($loyalty_point_input.val()) < 0
      ) {
        // eslint-disable-next-line no-undef
        return alert(mi_language.loyalty_point_exceed);
      }

      $.ajax({
        method: "POST",
        // eslint-disable-next-line no-undef
        url: parameters.url_admin_ajax,
        data: {
          // eslint-disable-next-line no-undef
          action: parameters.applyLoyaltyPoint.action,
          // eslint-disable-next-line no-undef
          nonce: parameters.applyLoyaltyPoint.nonce,
          loyalty_point: $loyalty_point_input.val() ?? 0,
        },
      })
        .done(() => {
          $(document.body).trigger("update_checkout");
        })
        .fail((err) => {
          alert(err.responseJSON.data.message);
        });
    });
  };

  try {
    apply_loyalty_point();
  } catch (error) {
    console.log(error);
  }
  // eslint-disable-next-line no-undef
})(jQuery);
